export default {
  signInTitle: '歡迎回來',
  signInSubtitle: '登入您的帳戶以繼續',
  signUpTitle: '建立帳戶',
  signUpSubtitle: '開始您的寵物照護之旅',
  forgotPasswordTitle: '忘記密碼',
  forgotPasswordSubtitle: '輸入您的電子郵件地址，我們會寄送重設密碼連結給您',
  resetPasswordTitle: '建立新密碼',
  resetPasswordSubtitle: '請輸入您的新密碼',
  
  emailPlaceholder: '電子郵件',
  passwordPlaceholder: '密碼',
  confirmPasswordPlaceholder: '確認密碼',
  newPasswordPlaceholder: '新密碼',
  confirmNewPasswordPlaceholder: '確認新密碼',
  
  signInButton: '登入',
  signUpButton: '註冊',
  sendResetEmailButton: '發送重設郵件',
  updatePasswordButton: '更新密碼',
  continueWithGoogle: '使用 Google 繼續',
  orDivider: '或',
  forgotPassword: '忘記密碼？',
  backToSignIn: '返回登入',
  
  noAccount: '還沒有帳戶？',
  alreadyHaveAccount: '已經有帳戶了？',
  
  signingYouIn: '登入中...',
  creatingAccount: '建立帳戶中...',
  sendingResetEmail: '發送郵件中...',
  updatingPassword: '更新密碼中...',
  
  signInSuccess: '登入成功！',
  accountCreatedAndSignedIn: '帳戶建立成功！正在登入...',
  resetEmailSent: '密碼重設郵件已發送！請檢查您的收件匣',
  passwordUpdatedSuccess: '密碼更新成功！正在跳轉到儀表板...',
  
  emailRequired: '請輸入電子郵件',
  emailInvalid: '電子郵件格式不正確',
  passwordRequired: '請輸入密碼',
  passwordTooShort: '密碼長度至少需要 6 個字元',
  confirmPasswordRequired: '請確認密碼',
  passwordMismatch: '兩次輸入的密碼不一致',
  
  invalidLoginCredentials: '電子郵件或密碼錯誤',
  userAlreadyRegistered: '此電子郵件已被註冊',
  emailNotConfirmed: '請先確認您的電子郵件',
  emailRateLimitExceeded: '請求過於頻繁，請稍後再試',
  securityRateLimit: '基於安全考量，您只能在 60 秒後再次請求',
  resetRequestCooldown: '基於安全考量，您只能在 15 秒後再次請求',
  userNotFound: '找不到此用戶',
  samePasswordError: '新密碼不能與舊密碼相同',
  resetLinkExpired: '重設連結已過期或無效',
  invalidResetLink: '無效的重設連結',
  resetLinkExpiredMessage: '此重設連結已過期或已被使用。請重新請求密碼重設。',
  verifyingResetLink: '驗證重設連結中...',
  
  googleSignInError: 'Google 登入失敗，請稍後再試',
  unexpectedError: '發生未預期的錯誤，請稍後再試',
};